import React, { useEffect, useState, useRef } from "react";
import Context from "../../Context";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/base";
import { CSVLink } from "react-csv";
import { Loading } from "../../components/modules";
import { FiFileText } from "react-icons/fi";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";
import { Spinner } from "reactstrap";
import { MdPersonSearch } from "react-icons/md";
import constant from "../../constants";

export const ReportAffiliate = () => {
  const { callApi, configs } = Context();
  const downloadRef = useRef(null);
  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [downloaded, setDownloaded] = useState([]); // to stop auto download (only happen on local)
  const [loading, setLoading] = useState(false);
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
  const [orders, setOrders] = useState(false);
  const [transactions, setTransactions] = useState(false);
  const [sortedData, setSortedData] = useState(false);
  useEffect(() => {
    if (csvFileName && !downloaded.includes(csvFileName)) {
      downloadRef.current.childNodes[0].click();
      setDownloaded((old) => [...old, csvFileName]);
    }
  }, [csvFileName]);

  const handleSearch = async () => {
    setLoading(true);

    const [orders, transactions] = await Promise.all([
      callApi("affiliates-getAffiliateOrder", {
        roundDate: selectedRoundDate,
      }),
      callApi("transactions-getAll", {
        roundDate: selectedRoundDate,
        queries: [["type", "deposit"]],
        orderBy: ["createdAt", "desc"],
        limit: 5000,
      }),
    ]);
    console.log("🚀 ~ handleSearch ~ transactions:", transactions);

    const sortedData = orders.data.reduce((acc, order) => {
      const { referrer } = order;
      acc[referrer] ? acc[referrer].push(order) : (acc[referrer] = [order]);

      return acc;
    }, {});

    setLoading(false);
    setOrders(orders.data);
    console.log("🚀 ~ handleSearch ~ orders.data:", orders.data);
    setSortedData(sortedData);
    console.log("🚀 ~ handleSearch ~ sortedData:", sortedData);

    setTransactions(transactions);
  };

  const handleDownload = async () => {
    const acc = [];
    acc.push([
      "ลำดับที่",
      "Affiliate Id",
      "ออเดอร์",
      "จำนวน (ใบ)",
      "รหัสผู้ซื้อ",
      "รายได้ที่ได้รับ",
    ]);

    await orders.map((order, index) => {
      acc.push([
        index + 1,
        order.referrer,
        order.shortId,
        order.size,
        order.userId,
        order.size * 12,
      ]);
    });

    setCsvData(acc);
    setCsvFileName(`รายงานรายได้ชวนเพื่อน_งวด_${selectedRoundDate}.csv`);
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mb-24">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานสรุปรายได้ชวนเพื่อน"
        icon={<FiFileText className="text-blue" />}
      />

      {/* rounddate select */}
      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold ">ค้นหาสรุปรายได้ชวนเพื่อน</p>
        </div>
        <div className="relative grid grid-cols-2 items-center gap-3 p-3 ">
          {loading && (
            <div className="z-50 bg-[rgb(255,255,255,0.7)] absolute h-full w-full flex justify-center items-center">
              <Spinner className="w-4 h-4 " />
            </div>
          )}
          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">งวด</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedRoundDate}
                onChange={(e) => setSelectedRoundDate(e.target.value)}
              >
                {configs.roundDates.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <button
            disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={() => {
              handleSearch();
            }}
          >
            <MdPersonSearch className="text-white" />
            ค้นหา
          </button>
          <button
            disabled={!orders.length}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
            onClick={() => {
              handleDownload();
            }}
          >
            {/* {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )} */}
            ดาวโหลด
          </button>
        </div>
      </div>
      {orders && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">สรุปคำสั่งซื้อชวนเพื่อนทั้งหมด</p>
          </div>
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="w-[60px] text-center">ลำดับ</TableHead>
                <TableHead className={`text-center w-[120px]`}>
                  ผู้แนะนำ
                </TableHead>
                <TableHead className={`text-center w-fit`}>
                  รหัสคำสั่งซื้อ
                </TableHead>
                <TableHead className={`text-center w-[100px]`}>
                  จำนวน (ใบ)
                </TableHead>
                <TableHead className="text-center">รหัสผู้ซื้อ</TableHead>
                {/* <TableHead className="text-center  w-[200px]">
                    รายได้ที่ได้รับ (ออเดอร์ละ 12 บาท)
                  </TableHead> */}
              </TableRow>
            </TableHeader>
            <TableBody>
              {orders.length > 0 ? (
                Object.entries(sortedData).map(([id, orders], index) => {
                  return (
                    <TableRow key={index} className={`align-top`}>
                      <TableCell className="font-medium text-center">
                        {index + 1}
                      </TableCell>
                      <TableCell className="font-semibold font-mono tabular-nums text-center">
                        {id}
                      </TableCell>
                      <TableCell className={``}>
                        {orders.map((order, index) => {
                          return (
                            <p
                              key={order.shortId}
                              className="font-semibold font-mono tabular-nums text-center"
                            >
                              {order.shortId}
                            </p>
                          );
                        })}
                      </TableCell>
                      <TableCell className={``}>
                        {orders.map((order, index) => {
                          return (
                            <p key={index} className="font-bold text-center ">
                              {" "}
                              {order.size}
                            </p>
                          );
                        })}
                      </TableCell>
                      <TableCell className={``}>
                        {orders.map((order, index) => {
                          return (
                            <p
                              key={index}
                              className="font-semibold font-mono tabular-nums text-center"
                            >
                              {" "}
                              {order.userId}
                            </p>
                          );
                        })}
                      </TableCell>
                      {/* <TableCell className="text-center font-bold text-green-500">
                        +{" "}
                        {orders.reduce((acc, order) => {
                          const baseIncome = 12;
                          acc += order.size * baseIncome;
                          return acc;
                        }, 0)}
                      </TableCell> */}
                    </TableRow>
                  );
                })
              ) : (
                <TableCell className="" colSpan="5">
                  <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                    <div>
                      <MdPersonSearch className="text-white" />
                      ไม่พบคำสั่งซื้อ
                    </div>
                  </div>
                </TableCell>
              )}
            </TableBody>
          </Table>
        </div>
      )}

      {orders && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">คำสั่งซื้อชวนเพื่อนทั้งหมด</p>{" "}
            <p className="text-xs font-semibold text-[#969797]">
              {orders.length} คำสั่งซื้อ
            </p>
          </div>

          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="text-center">ลำดับที่</TableHead>
                <TableHead className="">วันที่-เวลา</TableHead>
                <TableHead className="text-center">รหัสผู้ใช้</TableHead>
                <TableHead className="text-center">รหัสคำสั่งซื้อ</TableHead>
                {/* <TableHead className="">ที่อยู่ผู้รับ</TableHead>
                <TableHead className="">สินค้า</TableHead> */}
                <TableHead className="text-center">จำนวนใบ</TableHead>
                <TableHead className="text-center">ราคา</TableHead>
                {/* <TableHead className="">ใช้คะแนน</TableHead> */}
                {/* <TableHead>ผู้สร้าง</TableHead> */}
                <TableHead className="text-center">สถานะ</TableHead>
                <TableHead className="text-right">ผู้แนะนำ</TableHead>
                {/* <TableHead>ผู้ยกเลิก</TableHead> */}
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {orders.length > 0 ? (
                orders.map((order, index) => {
                  return (
                    <TableRow key={order.shortId}>
                      <TableCell className={`font-medium text-center`}>
                        {index + 1}
                      </TableCell>
                      <TableCell className={`font-medium`}>
                        {new Date(order.createdAt).toLocaleDateString("th-TH", {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                        })}{" "}
                        น.
                      </TableCell>
                      <TableCell className="font-semibold text-center tracking-widest font-mono">
                        {order.userId}
                      </TableCell>
                      <TableCell className="font-semibold text-center tracking-widest font-mono">
                        {order.shortId}
                      </TableCell>
                      <TableCell className="font-semibold text-center tracking-widest font-mono">
                        {order.size}
                      </TableCell>
                      {/* <TableCell className="font-medium">
                        {order.receiver?.address}
                      </TableCell>

                      <TableCell className="">
                        {order.product.map((prod) => (
                          <p className={``}>{prod.name}</p>
                        ))}
                      </TableCell> */}
                      <TableCell className="font-semibold text-center">
                        {`${order.totalPrice}`.toLocaleString() || 0}
                      </TableCell>
                      {/* <TableCell
                        className={`${order.isPoint ? "text-green" : "text-failed"} font-medium `}
                      >
                        {order.isPoint ? "Y" : "N"}
                      </TableCell> */}
                      {/* <TableCell className="font-medium">
                        {order.createdByAdmin
                          ? order.createdBy?.firstName +
                            " " +
                            order.createdBy?.lastName +
                            ` #${order.createdBy?.userId}`
                          : "-"}
                      </TableCell> */}
                      <TableCell className="font-medium text-center">
                        {constant.statusesTranslate[order.status]}
                      </TableCell>
                      <TableCell className="font-semibold text-right tracking-widest font-mono">
                        {order.referrer}
                      </TableCell>

                      {/* <TableCell>{order.cancelerName}</TableCell> */}
                    </TableRow>
                  );
                })
              ) : (
                <TableCell className="" colSpan="8">
                  <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                    <div>
                      <MdPersonSearch className="text-white" />
                      ไม่พบคำสั่งซื้อ
                    </div>
                  </div>
                </TableCell>
              )}
            </TableBody>
          </Table>
        </div>
      )}

      {transactions && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">ธุรกรรม</p>{" "}
            <p className="text-xs font-semibold text-[#969797]">
              {transactions.length} คำสั่งซื้อ
            </p>
          </div>

          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="text-center">ลำดับที่</TableHead>
                <TableHead className="">วันที่-เวลา</TableHead>
                <TableHead className="text-center">transaction no</TableHead>
                <TableHead className="text-center">รหัสผู้รับ</TableHead>
                {/* <TableHead className="">ที่อยู่ผู้รับ</TableHead>
                <TableHead className="">สินค้า</TableHead> */}
                <TableHead className="text-center">
                  ชื่อ-นามสกุลผู้รับ
                </TableHead>
                <TableHead className="text-right">รายได้ก่อนเพิ่ม</TableHead>
                {/* <TableHead className="">ใช้คะแนน</TableHead> */}
                {/* <TableHead>ผู้สร้าง</TableHead> */}
                <TableHead className="text-right">รายได้ที่ได้รับ</TableHead>
                <TableHead className="text-right">รายได้คงเหลือ</TableHead>
                <TableHead className="text-right">หมายเหตุ</TableHead>
                {/* <TableHead>ผู้ยกเลิก</TableHead> */}
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {transactions.length > 0 ? (
                transactions.map((transaction, index) => {
                  return (
                    <TableRow key={transaction.shortId}>
                      <TableCell className={`font-medium text-center`}>
                        {index + 1}
                      </TableCell>
                      <TableCell className={`font-medium`}>
                        {new Date(transaction.createdAt).toLocaleDateString(
                          "th-TH",
                          {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                            hour: "numeric",
                            minute: "numeric",
                          },
                        )}{" "}
                        น.
                      </TableCell>
                      <TableCell className="font-semibold text-center tracking-widest font-mono">
                        {transaction.shortId}
                      </TableCell>
                      <TableCell className="font-semibold text-center tracking-widest font-mono">
                        {transaction.userId}
                      </TableCell>
                      <TableCell className="font-semibold text-center">
                        {transaction.firstName} {transaction.lastName}
                      </TableCell>
                      {/* <TableCell className="font-medium">
                        {transaction.receiver?.address}
                      </TableCell>

                      <TableCell className="">
                        {transaction.product.map((prod) => (
                          <p className={``}>{prod.name}</p>
                        ))}
                      </TableCell> */}
                      <TableCell className="font-semibold text-right tracking-widest font-mono">
                        {transaction.balanceBefore}
                      </TableCell>
                      {/* <TableCell
                        className={`${transaction.isPoint ? "text-green" : "text-failed"} font-medium `}
                      >
                        {transaction.isPoint ? "Y" : "N"}
                      </TableCell> */}
                      {/* <TableCell className="font-medium">
                        {transaction.createdByAdmin
                          ? transaction.createdBy?.firstName +
                            " " +
                            transaction.createdBy?.lastName +
                            ` #${transaction.createdBy?.userId}`
                          : "-"}
                      </TableCell> */}
                      <TableCell className="font-semibold text-right tracking-widest font-mono">
                        {transaction.amount}
                      </TableCell>
                      <TableCell className="font-semibold text-right tracking-widest font-mono">
                        {transaction.balanceAfter}
                      </TableCell>
                      <TableCell className={``}>
                        {transaction.notes.map((order, index) => {
                          return (
                            <p key={index} className="font-semibold text-right">
                              {order.note}
                            </p>
                          );
                        })}
                      </TableCell>
                      {/* <TableCell>{order.cancelerName}</TableCell> */}
                    </TableRow>
                  );
                })
              ) : (
                <TableCell className="" colSpan="9">
                  <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                    <div>
                      <MdPersonSearch className="text-white" />
                      ไม่พบคำสั่งซื้อ
                    </div>
                  </div>
                </TableCell>
              )}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
};
